import { render, staticRenderFns } from "./AtSwitch.vue?vue&type=template&id=2ebe2928&"
import script from "./AtSwitch.vue?vue&type=script&lang=js&"
export * from "./AtSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports